import React from 'react';
import PropTypes from 'prop-types';
import { Textfit } from 'react-textfit';
import { formatPercentOneDecimal, SUMMARY_LEVELS } from '@bingads-webui-campaign/recommendation-core';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';

export const OverallOptimizationScore = (props) => {
  const {
    overallOptimizationScoreBar,
    newI18n,
    scope,
  } = props;

  if (!overallOptimizationScoreBar) {
    return null;
  }

  const { Gained, Dismissed } = overallOptimizationScoreBar;
  const { levelAt } = scope;

  return (
    <div className="overall-optimization-score">
      <div className="overall-optimization-score-number">
        <Textfit mode="single" forceSingleModeWidth={false}>{formatPercentOneDecimal(Gained + Dismissed, newI18n)}</Textfit>
      </div>
      <div className="overall-optimization-score-note">
        {levelAt === SUMMARY_LEVELS.CAMPAIGN ?
            newI18n.getString(_TL_('Your campaign optimization score')) : newI18n.getString(_TL_('Your account optimization score'))}
        <HelpPopupInline
          topic="pop_BA_Recommendations_OptScoreAcct"
          ariaLabel={newI18n.getString(_TL_('Click to learn more about optimization score'))}
        />
      </div>
    </div>
  );
};

OverallOptimizationScore.propTypes = {
  overallOptimizationScoreBar: PropTypes.shape({
    Gained: PropTypes.number,
    Dismissed: PropTypes.number,
    Available: PropTypes.number,
  }),
  scope: PropTypes.shape({
    levelAt: PropTypes.string,
  }),
  newI18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

OverallOptimizationScore.defaultProps = {
  overallOptimizationScoreBar: null,
  scope: null,
};
